import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import dashboard from "../views/dashboard.vue";
import profile from "../views/profile.vue";
import products from "../views/products.vue";
import vendors from "../views/vendors.vue";
import category from "../views/category.vue";
import storeroom from "../views/storeroom.vue";
import storeroomstock from "../views/storeroom._stock.vue";
import shop from "../views/shop.vue";
import newbill from "../views/newBill.vue";
import bill from "../views/bill.vue";
import printbill from "../views/printBill.vue";
import newuser from "../views/createuser.vue";
import newStock from "../views/newStock.vue";
import storeroomupdate from "../views/storeroomupdate.vue";

import purchaseOrder from "../views/purchase/purchaseOrder.vue";
import saledOrder from "../views/purchase/salesOrder.vue";
import purchaseOrderItems from "../views/purchase/purchaseDetials.vue";

//! online store
import onlineDash from "../views/online/dashboard.vue";
import onlineCategory from "../views/online/categories.vue";
import onlineItems from "../views/online/items.vue";
import onlineOrders from "../views/online/orders.vue";
import onlineOrdersItems from "../views/online/orderItems.vue";
import onlineSlider from "../views/online/slider.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/DASHBOARD",
    name: "dashboard",
    component: dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/NEWBILL",
    name: "newbill",
    component: newbill,
    meta: { requiresAuth: true },
  },
  {
    path: "/BILL",
    name: "bill",
    component: bill,
    meta: { requiresAuth: true },
  },
  {
    path: "/BILL/:id",
    name: "PRINTBILL",
    component: printbill,
    meta: { requiresAuth: true },
  },
  {
    path: "/PRODUCTS",
    name: "PRODUCTS",
    component: products,
    meta: { requiresAuth: true },
  },
  {
    path: "/CATEGORY",
    name: "CATEGORY",
    component: category,
    meta: { requiresAuth: true },
  },
  {
    path: "/PROFILE",
    name: "profile",
    component: profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/NEWUSER",
    name: "newuser",
    component: newuser,
    meta: { requiresAuth: true },
  },
  {
    path: "/VENDORS",
    name: "vendors",
    component: vendors,
    meta: { requiresAuth: true },
  },
  {
    path: "/STOREROOM",
    name: "STOREROOM",
    component: storeroom,
    meta: { requiresAuth: true },
  },
  {
    path: "/STOREROOM/:id",
    name: "STOREROOMSTOCK",
    component: storeroomstock,
    meta: { requiresAuth: true },
  },
  {
    path: "/STOREROOM_UPDATE/:id/:uid",
    name: "STOREROOM_UPDATE",
    component: storeroomupdate,
    meta: { requiresAuth: true },
  },
  {
    path: "/NEWSTOCK",
    name: "newStock",
    component: newStock,
    meta: { requiresAuth: true },
  },
  {
    path: "/PURCHASE_ORDER",
    name: "PURCHASE_ORDER",
    component: purchaseOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/PURCHASE_ORDER/:id",
    name: "PURCHASE_ORDER_DETIALS",
    component: purchaseOrderItems,
    meta: { requiresAuth: true },
  },
  {
    path: "/SALES_ORDER",
    name: "SALES_ORDER",
    component: saledOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/ONLINE",
    name: "ONLINE",
    component: onlineDash,
    meta: { requiresAuth: true },
  },
  {
    path: "/ONLINE_CATEGORY",
    name: "ONLINE_CATEGORY",
    component: onlineCategory,
    meta: { requiresAuth: true },
  },
  {
    path: "/ONLINE_ITEMS",
    name: "ONLINE_ITEMS",
    component: onlineItems,
    meta: { requiresAuth: true },
  },
  {
    path: "/ONLINE_ORDERS",
    name: "ONLINE_ORDERS",
    component: onlineOrders,
    meta: { requiresAuth: true },
  },
  {
    path: "/ONLINE_ORDERS/:id",
    name: "ONLINE_ORDERS_ITEMS",
    component: onlineOrdersItems,
    meta: { requiresAuth: true },
  },
  {
    path: "/ONLINE_SLIDER",
    name: "ONLINE_SLIDER",
    component: onlineSlider,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (Vue.prototype.$session.get("isLoggedIn")) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});
export default router;
